import { render, staticRenderFns } from "./LocaleDropdownMenu.vue?vue&type=template&id=09b6732c"
import script from "./LocaleDropdownMenu.vue?vue&type=script&lang=js"
export * from "./LocaleDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports